<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">history</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Histórico</h2>
    <p class="modal-subtitle">{{ data.titulo }}</p>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
  @if (isLoading) {
  <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
  <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
  <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
  } @else {
  <app-timeline-historico
    [itens]="itens"
    [exibirFiltros]="true"
    [permiteAnotacao]="podeAnotar"
    [botaoAnotacaoNoRodape]="true"
    [registrandoAnotacao]="isRegistrandoAnotacao"
    (registrarAnotacao)="registrarAnotacao($event)"></app-timeline-historico>
  }
</mat-dialog-content>

<!-- Fechar fica no X do cabeçalho. O rodapé abre a anotação, que troca o conteúdo do modal, e com ela aberta
  vira Cancelar e Registrar; os dois voltam para o histórico. -->
@if (podeAnotar && !isLoading) {
<mat-dialog-actions class="modal-footer">
  @if (timeline?.isAnotacaoAberta) {
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isRegistrandoAnotacao" (click)="timeline?.limparAnotacao()">
    Cancelar
  </button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isRegistrandoAnotacao"
    [disabled]="!timeline?.podeRegistrarAnotacao"
    [attr.aria-label]="isRegistrandoAnotacao ? 'Registrando anotação' : 'Registrar'"
    (click)="timeline?.registrar()">
    <mat-icon class="material-symbols-outlined">check</mat-icon>
    Registrar
    @if (isRegistrandoAnotacao) { <mat-spinner diameter="20"></mat-spinner> }
  </button>
  } @else {
  <button mat-flat-button type="button" class="btn-primary" (click)="timeline?.abrirAnotacao()">
    <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
    Nova anotação
  </button>
  }
</mat-dialog-actions>
}
